module.exports = __webpack_public_path__ + "static/media/logo_secai-1.a81cb76a.png";